export const COPY_URL_PATTERN = /https?:\/\/[^\s<>]+/gi;
export const COPY_URL_WRAPPER_PATTERN = /(\*+|_+|`+|["'([{])$/;
export const COPY_URL_WRAPPER_SUFFIX = /^[.,!?:;*_`"')\]}]*$/;
export const COPY_URL_BRACKETS: Readonly<Record<string, string>> = {
  "(": ")",
  "[": "]",
  "{": "}",
};
export const COPY_MARKDOWN_PATTERN = /\*\*|\*|__|_/g;
